/**
 * @generated SignedSource<<9fbd901c97cf05ca391d7d01356f5f4a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4AppMenuItem$data = {
  readonly appId: string | null;
  readonly envLabel: string | null;
  readonly iconUrl: string | null;
  readonly label: string | null;
  readonly sections: ReadonlyArray<{
    readonly label: string | null;
    readonly links: ReadonlyArray<{
      readonly label: string | null;
      readonly styleClass: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null> | null;
  readonly settingsUrl: string | null;
  readonly styleClass: string | null;
  readonly url: string | null;
  readonly " $fragmentType": "Nav4AppMenuItem";
};
export type Nav4AppMenuItem$key = {
  readonly " $data"?: Nav4AppMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4AppMenuItem">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "label"
},
v1 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4AppMenuItem",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "appId"
    },
    {
      "kind": "ScalarField",
      "name": "envLabel"
    },
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "concreteType": "JiraAppSection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "concreteType": "JiraAppNavigationItemNestedLink",
          "kind": "LinkedField",
          "name": "links",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            (v1/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "settingsUrl"
    },
    (v2/*: any*/)
  ],
  "type": "JiraAppNavigationItem"
};
})();

(node as any).hash = "fe622bd16e14b11ec5e3f21d8553bac3";

export default node;
